import "moment/locale/it"
import { Col, Row } from "react-bootstrap"
import { Progress } from "antd"
import { statNumberToString } from "../../../../apis/transform/stats"
import style from "./style.module.scss"
import cx from "classnames"

export function Passes({
  passes,
  shortPasses,
  longPasses,
  percentagePasses,
}: {
  passes: number
  shortPasses?: number
  longPasses?: number
  percentagePasses: number
}) {
  return (
    <div className={style.passesContainer}>
      <Row className={cx(style.passesRow, style.noBottomBorder)}>
        <dl>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.label}>
            <dt>Passaggi</dt>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.value}>
            <dd>{passes}</dd>
          </Col>
        </dl>
      </Row>
      <Row className={cx(style.passesRow, style.noTopBorder)}>
        <dl>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.label}>
            <dt>Precisione Passaggi</dt>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.value}>
            <dd>{parseFloat(statNumberToString(percentagePasses))}%</dd>
          </Col>
        </dl>
        {percentagePasses > 0 && (
          <Col>
            <Progress
              percent={percentagePasses}
              size="small"
              showInfo={false}
              strokeLinecap={"square"}
              strokeColor={"#f4c400"}
              trailColor="white"
            />
          </Col>
        )}
      </Row>
      {shortPasses && longPasses && (
        <Row className={cx(style.passesRow, style.whiteBg)}>
          <dl>
            <Col xs={6} sm={6} md={4} lg={4} xl={4} className={style.label}>
              <dt>Passaggi corti</dt>
            </Col>
            <Col xs={6} sm={6} md={2} lg={2} xl={2} className={style.value}>
              <dd>{shortPasses}</dd>
            </Col>
            <Col xs={6} sm={6} md={4} lg={4} xl={4} className={style.label}>
              <dt className={style.ml}>Passaggi lunghi</dt>
            </Col>
            <Col xs={6} sm={6} md={2} lg={2} xl={2} className={style.value}>
              <dd>{longPasses}</dd>
            </Col>
          </dl>
        </Row>
      )}
      {/* <Row>
        <Col sm={6} className={"centerColumn"}>
          <Row className={"marginBottom20"}>
            <Col className={"centerColumn"}>
              <Row>
                <Col className={"competitionSeasonValueLarge"}>{statNumberToString(passes)}</Col>
              </Row>
              <Row>
                <Col className={"competitionSeasonLabel"}>
                  <h2>Passaggi</h2>
                </Col>
              </Row>
            </Col>
          </Row>
          {shortPasses && longPasses && (
            <Row className={"marginTop20"}>
              <Col sm={6} className={"text-center"}>
                <Row>
                  <Col className={"competitionSeasonValue"}>{statNumberToString(shortPasses)}</Col>
                </Row>
                <Row>
                  <Col>
                    <Progress
                      className={"paddingLeftRight15"}
                      percent={(shortPasses / passes) * 100}
                      size="small"
                      showInfo={false}
                      strokeLinecap={"square"}
                      strokeColor={"#f4c400"}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className={"competitionSeasonLabel"}>
                    <h2>Corti</h2>
                  </Col>
                </Row>
              </Col>
              <Col sm={6} className={"text-center"}>
                <Row>
                  <Col className={"competitionSeasonValue"}>{statNumberToString(longPasses)}</Col>
                </Row>
                <Row>
                  <Col>
                    <Progress
                      className={"paddingLeftRight15"}
                      percent={(longPasses / passes) * 100}
                      size="small"
                      showInfo={false}
                      strokeLinecap={"square"}
                      strokeColor={"#f4c400"}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className={"competitionSeasonLabel"}>
                    <h2>Lunghi</h2>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Col>
        <Col sm={6} className={"centerColumn"}>
          <Row className={"marginBottom20"}>
            <Col>
              <Progress
                type="circle"
                percent={parseFloat(statNumberToString(percentagePasses))}
                strokeLinecap={"square"}
                strokeColor={"#f4c400"}
                width={140}
              />
            </Col>
          </Row>
          <Row>
            <Col className={"competitionSeasonLabel"}>
              <h2>Precisione passaggi</h2>
            </Col>
          </Row>
        </Col>
      </Row> */}
    </div>
  )
}
